import { isEmpty } from 'lodash';
import { DEFAULT_PAGE } from '../../constants';

export const pageUrl = ({ id, page, queryParameters, pathfinder }) => {
    let query = {
        ...queryParameters,
        page,
    };

    if (page === DEFAULT_PAGE) {
        delete query.page;
    }

    query = isEmpty(query) ? null : query;

    return pathfinder('tag_page', { id }, { query });
};

export const fullPageUrl = ({ id, page, queryParameters, pathfinder, url }) => {
    const baseUrl = new URL(url).origin;
    const path = pageUrl({ id, page, queryParameters, pathfinder });

    return baseUrl + path;
};
